export function clipLineToBox(
  x1: number,
  y1: number,
  x2: number,
  y2: number,
  xmin: number,
  ymin: number,
  xmax: number,
  ymax: number,
): {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
} | null {
  const INSIDE = 0; // 0000
  const LEFT = 1; // 0001
  const RIGHT = 2; // 0010
  const BOTTOM = 4; // 0100
  const TOP = 8; // 1000

  // Compute the outcode for a point (x, y)
  function computeOutCode(x, y) {
    let code = INSIDE;

    if (x < xmin) code |= LEFT;
    else if (x > xmax) code |= RIGHT;
    if (y < ymin) code |= BOTTOM;
    else if (y > ymax) code |= TOP;

    return code;
  }

  let outCode1 = computeOutCode(x1, y1);
  let outCode2 = computeOutCode(x2, y2);

  let accept = false;

  while (true) {
    if (!(outCode1 | outCode2)) {
      // Both endpoints are inside the box
      accept = true;
      break;
    } else if (outCode1 & outCode2) {
      // Both endpoints share an outside zone, no part of the line is inside
      break;
    } else {
      // Some part of the line is inside the box
      let x, y;

      // Choose an endpoint that is outside the box
      const outCodeOut = outCode1 ? outCode1 : outCode2;

      if (outCodeOut & TOP) {
        // Point is above the box
        x = x1 + ((x2 - x1) * (ymax - y1)) / (y2 - y1);
        y = ymax;
      } else if (outCodeOut & BOTTOM) {
        // Point is below the box
        x = x1 + ((x2 - x1) * (ymin - y1)) / (y2 - y1);
        y = ymin;
      } else if (outCodeOut & RIGHT) {
        // Point is to the right of the box
        y = y1 + ((y2 - y1) * (xmax - x1)) / (x2 - x1);
        x = xmax;
      } else if (outCodeOut & LEFT) {
        // Point is to the left of the box
        y = y1 + ((y2 - y1) * (xmin - x1)) / (x2 - x1);
        x = xmin;
      }

      // Move the outside point to the intersection point
      // and get the new outcode
      if (outCodeOut === outCode1) {
        x1 = x;
        y1 = y;
        outCode1 = computeOutCode(x1, y1);
      } else {
        x2 = x;
        y2 = y;
        outCode2 = computeOutCode(x2, y2);
      }
    }
  }

  if (accept) {
    // Return the clipped line coordinates
    return { x1, y1, x2, y2 };
  } else {
    // Return null if the line is completely outside the box
    return null;
  }
}
